import { faEdit, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateBrand } from "../../redux/features/brands/brandsSlice";
import { toast } from "react-toastify";

function UpdateBrand({ brandId, refetchBrands }) {
  const dispatch = useDispatch();
  const { brands, updateBrandLoading } = useSelector((state) => state.brands);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    logo: null,
  });
  const [errors, setErrors] = useState({});
  const [preview, setPreview] = useState(null);

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  useEffect(() => {
    const brand = brands.find((b) => b.id === brandId);
    if (brand) {
      const { name, logo } = brand;
      setFormData({ name, logo });
      setPreview(logo);
    }
  }, [brandId, brands]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "logo") {
      const file = files[0];
      setFormData((prev) => ({ ...prev, logo: file }));

      // Create a local URL for the preview
      if (file) {
        setPreview(URL.createObjectURL(file));
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.logo) newErrors.logo = "Logo is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Please fill all required fields correctly.");
      return;
    }

    try {
      const payload = new FormData();
      payload.append("name", formData.name);

      if (formData.logo instanceof File) {
        payload.append("logo", formData.logo);
      }
      await dispatch(
        updateBrand({ brandData: payload, brandId: brandId }),
      ).unwrap();

      toast.success("Brand Updated Successfully");
      handleClose();
      refetchBrands();
    } catch (error) {
      if (error?.errors) {
        const formattedErrors = {};

        Object.keys(error.errors).forEach((key) => {
          formattedErrors[key] = error.errors[key][0];
        });

        setErrors(formattedErrors);
      } else if (error?.message) {
        toast.error(error.message);
      } else {
        toast.error("Updates Failed");
      }
    }
  };
  return (
    <div>
      <button
        onClick={handleOpen}
        className="text-green-600 hover:text-green-700 font-medium"
      >
        <FontAwesomeIcon icon={faEdit} />
      </button>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-lg w-[45%]  p-10 relative">
            <button
              onClick={handleClose}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <h2 className="text-xl font-semibold border-b border-gray-200 mb-6 pb-5 text-left">
              Update Brand
            </h2>

            <form onSubmit={handleSubmit} className="space-y-10">
              <div className="grid grid-cols-1 gap-5">
                <div>
                  <label className="block text-gray-700 font-medium mb-1 text-left">
                    Brand Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter Brand Name"
                    className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-purpleColor"
                  />
                  {errors.name && (
                    <p className="text-red-500 text-sm text-left">{errors.name}</p>
                  )}
                </div>
              </div>
              <div className="flex flex-col items-start">
                <label className="block text-gray-700 font-medium mb-1 text-left">
                  Logo <span className="text-red-500">*</span>
                </label>

                <div className="mb-4">
                  {preview ? (
                    <div className="relative w-32 h-32 border rounded-lg overflow-hidden bg-gray-50">
                      <img
                        src={preview}
                        alt="Brand Preview"
                        className="w-full h-full object-contain"
                      />
                    </div>
                  ) : (
                    <div className="w-32 h-32 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-400">
                      No Image
                    </div>
                  )}
                </div>

                <input
                  type="file"
                  name="logo"
                  accept="image/*"
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-md p-2 text-sm text-gray-500 cursor-pointer"
                />

                {errors.logo && (
                  <p className="text-red-500 text-sm mt-1 text-left">{errors.logo}</p>
                )}
              </div>

              <div className="flex justify-end gap-3 mt-6">
                <button
                  type="button"
                  onClick={handleClose}
                  className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={updateBrandLoading}
                  className={`px-4 py-2 rounded-md text-white ${
                    updateBrandLoading
                      ? "bg-lightPurple/60 cursor-not-allowed"
                      : "bg-lightPurple hover:bg-purpleColor"
                  }`}
                >
                  {updateBrandLoading ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default UpdateBrand;
